import I18n from 'I18n';
import { Select } from 'foundations-components/transitional/components/Select';
import { useEffect, useMemo, useState } from 'react';
import useDebouncedValue from 'academy-common-lib/hooks/useDebouncedValue';
import RouterLink from 'ui-addon-react-router-dom/RouterLink';
import FloatingAlertStore from 'UIComponents/alert/FloatingAlertStore';
import usageTracker from '../../../utils/usageTracker';
import { usePublicCatalogResults } from '../../publicCatalog';
import { getPublicBasename } from '../../../utils/urls';
import { useHistory } from 'react-router-dom';
import { jsx as _jsx } from "react/jsx-runtime";
const SearchResultItem = ({
  children,
  option
}) => {
  if (option.isLink) {
    return /*#__PURE__*/_jsx(RouterLink, {
      display: "block",
      minBlockSize: "40px",
      paddingBlock: "200",
      paddingInline: "500",
      to: option.value // This creates a proper <a> tag, but the UISelect component hijacks the clicks requiring a history.push on change
      ,
      use: option.isAllResultsLink ? undefined : 'unstyled',
      children: option.text
    });
  }
  return children;
};
const PublicSearch = () => {
  const [value, setValue] = useState('');
  const history = useHistory();
  const debouncedValue = useDebouncedValue(value, 500);
  const {
    publicCatalogData,
    publicCatalogLoading,
    publicCatalogError
  } = usePublicCatalogResults({
    search: debouncedValue,
    pageLength: 3
  }, {
    skip: debouncedValue.length < 3
  });
  useEffect(() => {
    if (!publicCatalogLoading && publicCatalogError) {
      FloatingAlertStore.addAlert({
        type: 'danger',
        message: I18n.text('academyPublic.publicNavSearch.errorMessage'),
        titleText: I18n.text('academyPublic.publicNavSearch.errorTitle')
      });
    }
  }, [publicCatalogError, publicCatalogLoading]);
  const selectOptions = useMemo(() => {
    if (!publicCatalogData || !value.length) return [];
    const options = publicCatalogData.results.map(({
      name,
      pagePath,
      contentType
    }) => {
      return {
        text: name,
        value: contentType === 'TRACK' ? `/courses/${pagePath}` : `/lessons/${pagePath}`,
        isLink: true
      };
    });
    return !publicCatalogData.hasMore ? options : [...options, {
      text: I18n.text('academyPublic.publicNavSearch.seeAll', {
        number: publicCatalogData.total
      }),
      value: `/courses?search=${debouncedValue}`,
      isLink: true,
      isAllResultsLink: true
    }];
  }, [debouncedValue, publicCatalogData, value]);
  return /*#__PURE__*/_jsx(Select, {
    anchorType: "input",
    filterOptions: false,
    isLoading: publicCatalogLoading,
    itemComponent: SearchResultItem,
    onChange: e => {
      usageTracker.track('navInteraction', {
        action: 'search-item-clicked',
        searchQuery: debouncedValue,
        href: `${getPublicBasename()}${e.target.value}`
      });
      history.push(e.target.value);
    },
    onInputValueChange: e => {
      setValue(e.target.value);
    },
    options: selectOptions,
    placeholder: I18n.text('academyPublic.publicNavSearch.placeholder'),
    value: value
  });
};
export default PublicSearch;